export const fieldSizes = {
    sm: "px-2.5 py-1.5 text-sm",
    md: "px-3 py-2 text-sm",
    lg: "px-4 py-3 text-base",
};
/** Build the className for a form control. `extra` is appended (e.g. `pr-9` for a chevron). */
export function fieldClasses(size, error, extra = "") {
    const state = error
        ? "border-danger text-content focus:border-danger focus:ring-danger/30"
        : "border-line text-content focus:border-primary focus:ring-primary/30";
    return `block w-full rounded-lg border bg-canvas shadow-sm transition-colors placeholder:text-muted focus:outline-none focus:ring-2 focus:ring-offset-0 disabled:cursor-not-allowed disabled:bg-surface-2 disabled:text-muted ${state} ${fieldSizes[size]} ${extra}`.trim();
}
/** The standard field label. */
export const fieldLabelClass = "text-sm font-medium text-content";
/** Inline error text under a control. */
export const fieldErrorClass = "text-sm text-danger";
/** Inline helper text under a control. */
export const fieldHelperClass = "text-sm text-muted";
//# sourceMappingURL=field.js.map